import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgApprovedFiles = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M10.41 15.723 17.135 9 16.08 7.946l-5.67 5.67-2.85-2.85-1.053 1.053 3.904 3.904ZM5.139 20.5c-.499 0-.925-.177-1.278-.53a1.741 1.741 0 0 1-.53-1.278V5.308c0-.499.177-.925.53-1.278.353-.353.78-.53 1.278-.53h4.45a2.212 2.212 0 0 1 .727-1.416c.421-.39.927-.584 1.515-.584a2.17 2.17 0 0 1 1.525.584c.422.389.66.86.717 1.416h4.45c.499 0 .925.177 1.278.53.353.353.53.779.53 1.278v13.384c0 .499-.177.925-.53 1.278-.353.353-.779.53-1.278.53H5.138Zm0-1.5h13.384a.294.294 0 0 0 .212-.096.294.294 0 0 0 .096-.212V5.308a.294.294 0 0 0-.096-.212.294.294 0 0 0-.212-.096H5.138a.294.294 0 0 0-.212.096.294.294 0 0 0-.096.212v13.384c0 .077.032.148.096.212a.294.294 0 0 0 .212.096ZM11.83 4.346a.729.729 0 0 0 .75-.75.729.729 0 0 0-.75-.75.728.728 0 0 0-.75.75.728.728 0 0 0 .75.75Z"
	})]
});
const ForwardRef = forwardRef(SvgApprovedFiles);
export { ForwardRef as ReactComponent };
